import { Button, HStack, Icon, Text } from "@chakra-ui/react"
import type { FC, ReactNode } from "react"

export type ViewMode = "list" | "map"

interface ViewModeToggleProps {
  value: ViewMode
  onChange: (value: ViewMode) => void
}

const ListIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <line x1="8" y1="6" x2="21" y2="6" />
    <line x1="8" y1="12" x2="21" y2="12" />
    <line x1="8" y1="18" x2="21" y2="18" />
    <circle cx="4" cy="6" r="1" fill="currentColor" stroke="none" />
    <circle cx="4" cy="12" r="1" fill="currentColor" stroke="none" />
    <circle cx="4" cy="18" r="1" fill="currentColor" stroke="none" />
  </svg>
)

const MapIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="3 6 9 3 15 6 21 3 21 18 15 21 9 18 3 21 3 6" />
    <line x1="9" y1="3" x2="9" y2="18" />
    <line x1="15" y1="6" x2="15" y2="21" />
  </svg>
)

const options: Array<{ value: ViewMode; label: string; icon: ReactNode }> = [
  { value: "list", label: "List", icon: <ListIcon /> },
  { value: "map", label: "Map", icon: <MapIcon /> },
]

const ViewModeToggle: FC<ViewModeToggleProps> = ({ value, onChange }) => (
  <HStack
    as="div"
    role="group"
    aria-label="View mode"
    bg="gray.100"
    borderRadius="md"
    p="1"
    gap="1"
    h="40px"
  >
    {options.map((option) => {
      const selected = value === option.value
      return (
        <Button
          key={option.value}
          type="button"
          size="sm"
          variant="ghost"
          h="32px"
          minW="78px"
          px={3}
          borderRadius="md"
          bg={selected ? "white" : "transparent"}
          color={selected ? "green.800" : "gray.600"}
          boxShadow={selected ? "sm" : "none"}
          aria-pressed={selected}
          onClick={() => onChange(option.value)}
          _hover={{ bg: selected ? "white" : "gray.200" }}
        >
          <HStack gap={1.5} justify="center">
            <Icon boxSize={4}>{option.icon}</Icon>
            <Text as="span" fontSize="sm" fontWeight="medium">
              {option.label}
            </Text>
          </HStack>
        </Button>
      )
    })}
  </HStack>
)

export default ViewModeToggle
